// Longhands only: shorthands like `font` compute to "" in Firefox.
const COPIED_STYLES = [
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontFamily",
  "fontSize",
  "fontWeight",
  "fontStyle",
  "letterSpacing",
  "lineHeight",
];

// Index where the first rendered row of a textarea ends, soft wraps included.
export function firstRowEnd(field, text) {
  const newline = text.indexOf("\n");
  const limit = newline === -1 ? text.length : newline;

  const cs = window.getComputedStyle(field);
  const mirror = document.createElement("div");
  COPIED_STYLES.forEach((prop) => (mirror.style[prop] = cs[prop]));
  Object.assign(mirror.style, {
    boxSizing: "border-box",
    width: `${field.clientWidth}px`,
    position: "absolute",
    visibility: "hidden",
    whiteSpace: "pre-wrap",
    overflowWrap: "break-word",
  });
  const node = document.createTextNode(text);
  mirror.appendChild(node);
  document.body.appendChild(mirror);

  try {
    const range = document.createRange();
    let firstTop = null;
    for (let i = 0; i < limit; i++) {
      range.setStart(node, i);
      range.setEnd(node, i + 1);
      const rect = range.getClientRects()[0];
      if (!rect) continue;
      if (firstTop === null) firstTop = rect.top;
      if (rect.top > firstTop + 2) {
        let end = i;
        while (end > 0 && text[end - 1] === " ") end--;
        return end;
      }
    }
    return limit;
  } finally {
    document.body.removeChild(mirror);
  }
}
